// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsuariosEdicionPage_containerCuerpo__sh5Xv {
  background-color: white;
}

.UsuariosEdicionPage_divFormulario__-tS5n {
}

.UsuariosEdicionPage_containerFilaBusqueda__VpNq0 {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.UsuariosEdicionPage_titulo__RIu7Y {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.UsuariosEdicionPage_divTodoEnUnaFila__HdrxR {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
}

.UsuariosEdicionPage_divCampos__zA7Xe {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
}

.UsuariosEdicionPage_divCamposItem__Tcoz2 {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.UsuariosEdicionPage_atributo__8Zh1D {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  color: var(--text-color-claro);
}

.UsuariosEdicionPage_valor__Jg0ce {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.UsuariosEdicionPage_divBotonera__5dOda {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.UsuariosEdicionPage_circleImage__5ATAL {
  width: 150px; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 50%; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.UsuariosEdicionPage_containerUsuario__ulYh2 {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;

  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */
  .UsuariosEdicionPage_containerGrillaUsuarios__xIC\\+V {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .UsuariosEdicionPage_containerUsuario__ulYh2 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }

  .UsuariosEdicionPage_circleImage__5ATAL {
    width: 200px; /* Ajusta el tamaño según tus necesidades */
    height: 200px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1100px) {
  .UsuariosEdicionPage_containerUsuario__ulYh2 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/usuarios/usuario-edicion/UsuariosEdicionPage.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;AACA;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY,EAAE,2CAA2C;EACzD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;EAEnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,YAAY,EAAE,2CAA2C;IACzD,aAAa,EAAE,8EAA8E;IAC7F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF","sourcesContent":[".containerCuerpo {\n  background-color: white;\n}\n\n.divFormulario {\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 150px; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 50%; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n\n  .circleImage {\n    width: 200px; /* Ajusta el tamaño según tus necesidades */\n    height: 200px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1100px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerCuerpo": `UsuariosEdicionPage_containerCuerpo__sh5Xv`,
	"divFormulario": `UsuariosEdicionPage_divFormulario__-tS5n`,
	"containerFilaBusqueda": `UsuariosEdicionPage_containerFilaBusqueda__VpNq0`,
	"titulo": `UsuariosEdicionPage_titulo__RIu7Y`,
	"divTodoEnUnaFila": `UsuariosEdicionPage_divTodoEnUnaFila__HdrxR`,
	"divCampos": `UsuariosEdicionPage_divCampos__zA7Xe`,
	"divCamposItem": `UsuariosEdicionPage_divCamposItem__Tcoz2`,
	"atributo": `UsuariosEdicionPage_atributo__8Zh1D`,
	"valor": `UsuariosEdicionPage_valor__Jg0ce`,
	"divBotonera": `UsuariosEdicionPage_divBotonera__5dOda`,
	"circleImage": `UsuariosEdicionPage_circleImage__5ATAL`,
	"containerUsuario": `UsuariosEdicionPage_containerUsuario__ulYh2`,
	"containerGrillaUsuarios": `UsuariosEdicionPage_containerGrillaUsuarios__xIC+V`
};
export default ___CSS_LOADER_EXPORT___;
